import { useDarkMode } from "../context/darkModeContext";
import { FaMoon, FaSun } from "react-icons/fa";
import "../css/DarkModeButton.css";

const DarkModeButton = (): JSX.Element => {
  const { darkMode, toggleDarkMode } = useDarkMode();
  return (
    <div
      onClick={toggleDarkMode}
      className={`darkmode-button${darkMode ? "--darkmode" : ""}`}
    >
      <FaMoon
        className={`darkmode-button-icon-left${darkMode ? "--darkmode" : ""}`}
      />
      <FaSun
        className={`darkmode-button-icon-right${darkMode ? "--darkmode" : ""}`}
      />
      <div
        className={
          darkMode
            ? "darkmode-button-circle-right"
            : "darkmode-button-circle-left"
        }
      ></div>
    </div>
  );
};

export default DarkModeButton;
